import { BaseModule } from "by/gamefactory/cityversetycoon/composition/module/BaseModule";
import { MyWalletModuleFlowExecutor } from "./MyWalletModuleFlowExecutor";
import { MyWalletController } from "./controllers/MyWalletController";
import { MyWalletPopupScene } from "./scenes/MyWalletPopupScene";
import { WalletDisconnectionResourcePackage } from "./resources/WalletDisconnectionResourcePackage";
import { MyWalletResourcePackage } from "./resources/MyWalletResourcePackage";
import { ParamDescription } from "by/gamefactory/cityversetycoon/composition/module/ParamDescription";
import { MyWalletModel } from "./model/MyWalletModel";
import { ExternalWalletType } from "../../../../web3/externalWallets/ExternalWalletType";
import { SignMessageController } from "./signMessage/controllers/SignMessageController";
import { SignMessageScene, SignMessageOptions } from "./signMessage/SignMessageScene";
import { WalletTabType } from "./components/WalletTabType";
import { WalletConnectMessagesScene } from "./walletConnectMessages/WalletConnectMessagesScene";
import { WalletConnectState } from "./walletConnectMessages/WalletConnectState";
import { MyWalletPopupSceneOptions } from "./scenes/MyWalletPopupSceneOptions";

export class MyWalletModule extends BaseModule<void> {
    private walletDisconnectionResourcePackage: WalletDisconnectionResourcePackage;
    private myWalletResourcePackage: MyWalletResourcePackage;

    public override async build(): Promise<void> {
        this.internalContainer.register(MyWalletModuleFlowExecutor, MyWalletModuleFlowExecutor);

        this.internalContainer.registerSingleton("IMyWalletModel", MyWalletModel);
        this.internalContainer.register("IMyWalletController", MyWalletController);
        this.internalContainer.register(MyWalletPopupScene, MyWalletPopupScene);
        this.internalContainer.register("MyWalletPopupSceneFactory", {
            useValue: async (options: MyWalletPopupSceneOptions) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    MyWalletPopupScene,
                    new ParamDescription("MyWalletPopupSceneOptions", options)
                );
            }
        });

        this.internalContainer.register("ISignMessageController", SignMessageController);
        this.internalContainer.register(SignMessageScene, SignMessageScene);
        this.internalContainer.register("SignMessageSceneFactory", {
            useValue: async (address: string, walletType?: ExternalWalletType) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    SignMessageScene,
                    new ParamDescription("SignMessageOptions", { address, walletType } as SignMessageOptions)
                );
            }
        });

        this.internalContainer.register(WalletConnectMessagesScene, WalletConnectMessagesScene);
        this.internalContainer.register("WalletConnectMessagesSceneFactory", {
            useValue: async (state: WalletConnectState, walletType?: ExternalWalletType) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    WalletConnectMessagesScene,
                    new ParamDescription("WalletConnectMessageOptions", { state, walletType })
                );
            }
        });

        this.walletDisconnectionResourcePackage = new WalletDisconnectionResourcePackage();
        await this.walletDisconnectionResourcePackage.load();
        this.internalContainer.registerInstance(WalletDisconnectionResourcePackage, this.walletDisconnectionResourcePackage);

        this.myWalletResourcePackage = new MyWalletResourcePackage();
        await this.myWalletResourcePackage.load();
        this.internalContainer.registerInstance(MyWalletResourcePackage, this.myWalletResourcePackage);

        await super.build();
    }

    public async start(forceTab?: WalletTabType): Promise<void> {
        const executor = await this.internalContainer.resolve(MyWalletModuleFlowExecutor);
        await executor.execute(this, forceTab);
        this.dispose();
    }

    public override dispose(): void {
        this.walletDisconnectionResourcePackage.destroy();
        this.myWalletResourcePackage.destroy();
        super.dispose();
    }
}
